<template>
  <div class="mt-3">
    <div class="header-purple">
      <div>
        <p class="mb-0">
          <strong>
            รายละเอียด
            <b-button
              v-if="collapseHeader"
              variant="link"
              size="sm"
              class="btn-collapse mb-1"
              @click="collapseHeader = false"
            >
              <b-icon icon="chevron-down"></b-icon>
            </b-button>
            <b-button
              v-if="!collapseHeader"
              variant="link"
              size="sm"
              class="btn-collapse  mb-1"
              @click="collapseHeader = true"
            >
              <b-icon icon="chevron-up"></b-icon>
            </b-button>
          </strong>
        </p>
      </div>
    </div>
    <b-collapse v-model="collapseHeader" class="collapse-header">
      <div class="p-4 bg-white">
        <b-row>
          <b-col sm="6">
            <InputText
              textFloat="หมายเลขชุดแบทช์"
              v-model="form.batchNo"
              isRequired
              placeholder="ชุดแบทช์"
              type="text"
              :isValidate="$v.form.batchNo.$error"
              :v="$v.form.batchNo"
            />
          </b-col>
          <b-col sm="6">
            <InputSelect
              title="ช่องทางการสั่งซื้อ"
              name="channel"
              v-model="form.orderChanel"
              isRequired
              v-bind:options="orderChannelOption"
              valueField="id"
              textField="name"
              @onDataChange="changeOrderChannel"
            />
          </b-col>
        </b-row>
      </div>
    </b-collapse>

    <div class="mt-4 header-purple">
      <div>
        <p class="mb-0">
          <strong>
            รายการสั่งซื้อ
          </strong>
        </p>
      </div>
    </div>
    <div class="p-4 bg-white">
      <b-table
        responsive
        striped
        sticky-header
        class="text-center"
        :fields="fields"
        :items="orderList"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
      >
        <template v-slot:head(id)="">
          <b-form-group class="cb-table">
            <b-form-checkbox
              v-model="selectAllOrder"
              @change="selectAllTable"
            ></b-form-checkbox>
          </b-form-group>
        </template>
        <template v-slot:cell(id)="data">
          <b-form-group class="cb-table">
            <b-form-checkbox
              :value="data.item.id"
              v-model="form.orderList"
            ></b-form-checkbox>
          </b-form-group>
        </template>
        <template v-slot:cell(orderNumberSystem)="data">
          <div class="text-left">
            <span class="m-0" v-if="data.item.orderNumberSystem">
              <b-icon icon="dot"></b-icon> {{ data.item.orderNumberSystem }}
            </span>
            <p v-else class="m-0">-</p>
          </div>
        </template>
        <template v-slot:cell(orderNumber)="data">
          <div class="text-left">
            <p class="m-0" v-if="data.item.orderNumber">
              {{ data.item.orderNumber }}
            </p>
            <p v-else class="m-0">-</p>
          </div>
        </template>
        <template v-slot:cell(orderDate)="data">
          <div class="date-text" v-if="data.item.orderDate">
            {{ new Date(data.item.orderDate) | moment($formatDateTime) }}
          </div>
          <div class="date-text" v-else><p class="m-0">-</p></div>
        </template>
        <template v-slot:cell(channel)="data">
          <div class="position-relative picture-text pic-table">
            <div
              v-if="data.item.channel"
              class="square-box b-contain pic-box"
              v-bind:style="{
                'background-image': 'url(' + data.item.channel + ')',
              }"
            ></div>
            <div v-else>-</div>
          </div>
        </template>
        <template v-slot:cell(manage)="data">
          <b-button variant="link" class="px-1 py-0">
            <router-link
              :to="
                '/batch/details/' +
                  data.item.orderId +
                  '?brandID=' +
                  $route.query.brandID
              "
              class="text-purple-1"
            >
              <u>ดูรายละเอียด</u>
            </router-link>
          </b-button>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
      </b-table>
    </div>
    <b-row class="mt-5">
      <b-col md="6">
        <b-button @click="backPage" class="btn btn-main-2">ยกเลิก</b-button>
      </b-col>
      <b-col md="6" class="text-sm-right">
        <template>
          <button
            type="button"
            class="btn btn-main ml-md-2 text-uppercase"
            @click="checkForm"
          >
            บันทึก
          </button>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { BIcon } from "bootstrap-vue";
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
export default {
  name: "CreateBatchPanel",
  components: { BIcon, InputText, InputSelect },
  data() {
    return {
      collapseHeader: true,
      isBusy: false,
      form: {
        batchNo: "",
        orderChanel: 0,
        orderList: [],
      },
      orderList: [],
      fields: [
        {
          key: "id",
          label: "",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "5%",
          },
        },
        {
          key: "orderNumberSystem",
          label: "หมายเลขคำสั่งซื้อระบบ",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "15%",
          },
        },
        {
          key: "orderNumber",
          label: "หมายเลขคำสั่งซื้อ",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "15%",
          },
        },
        {
          key: "orderDate",
          label: "วันที่สั่งซื้อ",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "10%",
          },
        },
        {
          key: "paymentChannel",
          label: "ช่องทางการชำระเงิน",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "12%",
          },
        },
        {
          key: "shippingChannel",
          label: "ช่องทางการจัดส่ง / หมายเลขพัสดุ",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "13%",
          },
        },
        {
          key: "channel",
          label: "ช่องทาง",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "10%",
          },
        },
        {
          key: "quantity",
          label: "จำนวนสินค้า",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "10%",
          },
        },
        {
          key: "manage",
          label: "",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "10%",
          },
        },
      ],
      orderChannelOption: [
        {
          id: 0,
          name: "Shopee"
        },
        {
          id: 1,
          name: "Lazada"
        },
      ],
      listAllOrderId: [],
      selectAllOrder: false,
    };
  },
  validations: {
    form: {
      batchNo: { required },
      orderChanel: { required },
      orderList: { required },
    },
  },
  watch: {
    "form.orderList": {
      handler(val) {
        this.selectAllOrder =
          this.form.orderList.length == this.listAllOrderId.length
            ? true
            : false;
      },
    },
  },
  methods: {
    changeOrderChannel(value) {
      this.form.orderChanel = value;
    },
    hasHistory() {
      return window.history.length > 2;
    },
    backPage() {
      if (this.hasHistory()) this.$router.back();
      else
        this.$router.push({
          path: `/batch?brandID=${this.$route.query.brandID}`,
        });
    },
    checkForm() {},
    submitForm() {},
    selectAllTable(value) {
      if (value) {
        this.form.orderList = this.listAllOrderId;
      } else {
        this.form.orderList = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .btn-select {
  height: 42.4px;
  margin-top: 1px;
  color: #404040;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  padding: 9px 10px;
  cursor: pointer;
}
::v-deep .btn-select.custom-select-lg {
  height: 55px;
  font-size: 1rem;
}
::v-deep .btn-select:focus {
  border-color: #80c141;
}
::v-deep .btn-select > option {
  background-color: white;
  color: #16274a;
}
::v-deep .btn-select > option:checked {
  color: #16274a !important;
}
::v-deep .btn-select:focus {
  box-shadow: unset !important;
}
.btn-collapse {
  color: #333333;
}
.text-gray {
  color: #bcbcbc;
}
.last-row {
  height: 47.4px;
  border-top: 2px solid white;
}
.cb-table {
  position: relative;
  margin-left: 15px;
  padding-top: 15px;
}
.GWP {
  background-color: #e3e2f2;
  color: #8078c6;
}
.pic-table {
  max-height: 65px !important;
}
.pic-box {
  max-height: 80px !important;
  background-size: cover !important;
  background-repeat: no-repeat;
  background-position: right top;
}
</style>
